var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.behavior.appView
    ? _c(
        "button",
        { staticClass: "btn-localize", on: { click: _vm.onClick } },
        [_c("i", { staticClass: "material-icons" }, [_vm._v("gps_fixed")])]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }